import PropTypes from 'prop-types'
import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../topic-section'

const NUM_VISIBLE_POSTS = 4

const FriendsAndFamilyView = ({ posts, subTopics }) => (
  <>
    {subTopics.map((childTopic, idx) => (
      <TopicSection
        key={`topic_section_${childTopic.slug}`}
        topic={{ name: childTopic.name, slug: childTopic.slug }}
        showTopics={false}
        posts={filterPostsByTopicSlug(posts, childTopic.slug).slice(
          0,
          NUM_VISIBLE_POSTS
        )}
      />
    ))}
  </>
)

FriendsAndFamilyView.propTypes = {
  posts: PropTypes.array,
  subTopics: PropTypes.array,
}

FriendsAndFamilyView.defaultProps = {
  posts: [],
  subTopics: [],
}

export default FriendsAndFamilyView
